import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enUS from "./locales/en-US/common.json";
import jaJP from "./locales/ja-JP/common.json";
import koKR from "./locales/ko-KR/common.json";
import viVN from "./locales/vi-VN/common.json";
import zhCN from "./locales/zh-CN/common.json";

const resources = {
  "ko-KR": { translation: koKR },
  ko: { translation: koKR },
  "en-US": { translation: enUS },
  en: { translation: enUS },
  "ja-JP": { translation: jaJP },
  ja: { translation: jaJP },
  "vi-VN": { translation: viVN },
  vi: { translation: viVN },
  "zh-CN": { translation: zhCN },
  zh: { translation: zhCN },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "ko-KR",
    supportedLngs: [
      "ko-KR",
      "ko",
      "en-US",
      "en",
      "ja-JP",
      "ja",
      "vi-VN",
      "vi",
      "zh-CN",
      "zh",
    ],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "app_locale",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.resolvedLanguage || i18n.language || "ko-KR";
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
  });
}

export default i18n;
